import calculatePriceWithDiscount from './calculatePriceWithDiscount';
import { BasePricingAttributes, INDEX } from './types';

/**
 * Retrieve the base CPT or CPM including discount based on a 2D array representation
 * of the 'Pricing' Google Sheet.
 *
 * @param pricingSheet 2D array representation of the 'Pricing' sheet
 * @returns Base CPT or CPM price including discount
 */
const getBasePrice = (
  pricingSheet: Array<Array<any>>,
  attributes: BasePricingAttributes
): number => {
  const rowIndex = getRowIndex(pricingSheet, attributes);
  if (rowIndex === INDEX.NOT_FOUND) return 0;

  const columnIndex = getColumnIndex(pricingSheet, attributes);
  if (columnIndex === INDEX.NOT_FOUND) return 0;

  return calculatePriceWithDiscount(
    pricingSheet[rowIndex][columnIndex],
    attributes.discount
  );
};

const getRowIndex = (
  pricingSheet: Array<Array<any>>,
  attribute: BasePricingAttributes
): number => {
  return pricingSheet.findIndex(
    (row: Array<any>) =>
      row[INDEX.DEMOGRAPHIC] === attribute.demographic &&
      row[INDEX.RATECARD] === attribute.ratecard
  );
};

const getColumnIndex = (
  pricingSheet: Array<Array<any>>,
  attribute: BasePricingAttributes
): number => {
  return pricingSheet[INDEX.HEADER_ROW].indexOf(attribute.month);
};

export default getBasePrice;
